import React from "react";

const NavItemSkeleton = () => {
  return (
    <div className="bg-nav-shell mb-2 h-7 w-full rounded px-2 py-2.5"></div>
  );
};

const NavBarSkeleton = () => {
  // arbitrary value, 6 looks pretty good though
  const numSkeletonItems = 6;
  return (
    <div className="mt-8">
      {[...Array(numSkeletonItems).keys()].map((idx) => (
        <NavItemSkeleton key={`NavItemSkeleton-${idx}`} />
      ))}
    </div>
  );
};

export default NavBarSkeleton;
